// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__668b8","colMin":"styles_colMin__EL6Zt"};